<template>
<div class="settings">
    <div class="columns">
        <div class="column is-one-quarter">
            <div class="columns">
                <div class="column is-11">
                    <settings-menu active-item="servers"></settings-menu>
                </div>
            </div>
        </div>
        <div class="column">
            <div class="settings-container">
                <div class="columns is-multiline">
                    <div v-if="loadingServers" class="column is-full has-text-centered">
                        <img src="/loader-dark.svg">
                    </div>
                    <div v-if="!loadingServers" class="column is-full">
                        <div class="columns is-multiline">
                            <div class="column is-3">
                                <div class="plan-page-label">Servers</div>
                                <div class="plan-page-description" style="font-size:13px !important;">
                                    Those are the servers Weap.io will use to create the Database backups.
                                </div>
                                <div class="plan-page-description" style="font-size:13px !important;">
                                    You can use the server on which the database is running or any other server that is able to connect to the database you want to backup.
                                    <!-- You can choose to use an existent server or to add a new one when adding a new database to be backed up. -->
                                </div>
                            </div>
                            <div class="column is-9" style="padding-left: 60px;">
                                <div class="columns is-multiline">
                                    <div v-if="servers.length < 1" class="column is-12">
                                        <div class="notification is-default" style="font-size: 13px;">
                                            Oops! You don't have any server added. Try to setup automated backups <router-link :to="{ name: 'databases' }"><b> for databases</b></router-link> or <router-link :to="{ name: 'files' }"><b>server files</b></router-link> and the server(s) used will appear in this list. 
                                        </div>
                                    </div>
                                    <div v-for="server in servers" v-bind:key="server.id" v-if="servers" class="column is-half">
                                        <router-link :to="{ name: 'serverSettings', params: { id: server.id } }">
                                            <div class="plan provider-box" style="border-radius:6px !important;">
                                                <div class="plan-details">
                                                    <div class="columns is-multiline">
                                                        <div class="column is-half" style="padding-bottom:0;">
                                                            <div class="plan-period" style="font-weight: 700;">{{ server.name }}</div>
                                                        </div>
                                                        <div class="column is-half has-text-right" style="padding-bottom:0;">
                                                            <font-awesome-icon icon="server" style="color:#999"/>
                                                        </div>
                                                        <div class="column is-half">
                                                            <div class="plan-price">
                                                                <span class="plan-period" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ serverInfo(server) }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="column is-half has-text-right">
                                                            <!-- <span class="plan-amount">15.33</span><span class="plan-period"> GB used</span> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';
import FormErrorsMixin from '@/mixins/FormErrors';

import SettingsMenu from '@/components/Settings/Menu.vue';

export default {
    components: {
        SettingsMenu,
    },

    mixins: [FormErrorsMixin],

    metaInfo: {
        title: 'Servers - Weap.io',
    },

    data() {
        return {
            servers: [],
            loadingServers: false,
        }
    },

    mounted() {
        this.getServers();
        this.listenEvents();
    },

    methods: {
        getServers() {
            if (this.loadingServers) {
                return;
            }

            this.loadingServers = true;

            Api().get('users/current/servers')
                .then((response) => {
                    this.servers = response.data.data;
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    this.loadingServers = false;
                });
        },

        listenEvents() {
            //
        },

        serverInfo(server) {
            var info = server.user + '@' + server.host;
            var maxLength = 37;

            if (info.length > maxLength) {
                info = info.substring(0, maxLength) + '...';
            }

            return info;
        },
    },
}
</script>
